var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.75h28c1.105 0 2-.784 2-1.75S31.105.25 30 .25H2C.895.25 0 1.034 0 2s.895 1.75 2 1.75ZM30 7.75H2c-1.105 0-2 .784-2 1.75s.895 1.75 2 1.75h28c1.105 0 2-.784 2-1.75s-.895-1.75-2-1.75ZM30 15.25H2c-1.105 0-2 .784-2 1.75s.895 1.75 2 1.75h28c1.105 0 2-.784 2-1.75s-.895-1.75-2-1.75Z",
    fill: "#053249"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M5.759 29.75v-4.112l1.648 4.112h.56l1.64-4.088v4.088h.696v-5.6h-.696l-1.92 4.568-1.92-4.568h-.704v5.6h.696Zm9.651 0v-.656h-2.456v-1.8h2.456v-.656h-2.456v-1.832h2.456v-.656h-3.184v5.6h3.184Zm2.512 0v-4.384l2.528 4.384h.768v-5.6h-.696v4.384l-2.52-4.384h-.776v5.6h.696Zm7.113.128c1.24 0 2.04-.688 2.04-1.968v-3.76h-.728v3.72c0 .888-.512 1.352-1.312 1.352-.792 0-1.304-.464-1.304-1.352v-3.72h-.728v3.76c0 1.28.8 1.968 2.032 1.968Z",
    fill: "#053249"
  })));
};
export default SvgHamburger;